import '@/assets/iconfont.js';
import '@/common/antd/index'; // 引入antd的额外配置 + 全局样式
import './assets/base.css';
import '@/fe_modules/assets/styles/common.scss'; //初始化全局样式
import '@transn/im-sdk/dist/style.css';
import 'nprogress/nprogress.css'; //全局加载样式
import './assets/main.scss';
import './assets/styles/ant.css';
import './assets/styles/ant-question.less';
// 小屏适配样式
import './assets/styles/mini-adapter.scss';
// 滚动条样式
import './assets/styles/scrollbar.css';
import './assets/styles/ant-question.less';

import { BrowserTracing } from '@sentry/tracing';
import * as Sentry from '@sentry/vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import { isProd, isTest } from '@/fe_modules/utils/runtime';

import App from './App.vue';
import router from './router';

const app = createApp(App);

Sentry.init({
  app,
  dsn: 'https://86225df098734a04b94441b515252da4@sentry.iol8.com/2',
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ['localhost', 'my-site-url.com', /^\//]
    })
  ],
  tracesSampleRate: 1.0,
  environment: isProd ? 'prod' : isTest ? 'test' : 'dev',
  logErrors: !isProd,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications.'
  ]
});
app.use(createPinia());
app.use(router);

app.mount('#app');
